import { useMemo } from 'react';
import { useAxios } from '../utils/hook/useAxios';

export default function useRecommendationsApi() {
  const axios = useAxios();

  return useMemo(
    () => ({
      fetchRecommendations: (params, signal) =>
        axios.get('/recommendations', { params, signal }).then((r) => r.data),

      trackEvents: (events) => axios.post('/recommendations/events', { events }).catch(() => {}), // jamais bloquant
    }),
    [axios]
  );
}
